<script>
  export let value;
  export let type = "";

  import CellString from './cell-types/cell-string.svelte';
  import CellRef from './cell-types/cell-ref.svelte';
  import CellDate from './cell-types/cell-date.svelte';
  import CellNumber from './cell-types/cell-number.svelte';
</script>

{#if type === "String"}
    <CellString bind:value={value}/>
{:else if type === 'Number'}
    <CellNumber bind:value={value}/>
{:else if type === 'Date'}
    <CellDate bind:value={value}/>
{:else if !!type.ref}
    <CellRef bind:value={value} ref="{type.ref}"/>
{:else}
    no preview
{/if}